import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/missingPreview.jpg'


const _withScopeId = n => (_pushScopeId("data-v-52d9ced5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-image" }
const _hoisted_3 = { class: "image" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 0,
  class: "card-content"
}
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "tags is-pulled-right" }
const _hoisted_9 = ["title"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "is-clearfix" }, null, -1))
const _hoisted_11 = { class: "card-footer" }
const _hoisted_12 = ["title"]
const _hoisted_13 = ["title", "onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-trash" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  title: "Preview this element on its image",
  class: "button",
  type: "button"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-eye" })
], -1))
const _hoisted_17 = ["title", "disabled"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-remove-square" }, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-check" }, null, -1))
const _hoisted_22 = [
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DeleteModal = _resolveComponent("DeleteModal")!
  const _component_PreviewDropdown = _resolveComponent("PreviewDropdown")!
  const _component_RemoveModal = _resolveComponent("RemoveModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: { name: 'element-details', params: { id: _ctx.element.id }, query: _ctx.routeQuery },
      title: `Navigate to ${_ctx.element.name}`
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("figure", _hoisted_3, [
            (!_ctx.thumbnailUrl || _ctx.imgFailed)
              ? (_openBlock(), _createElementBlock("img", _hoisted_4))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: _ctx.thumbnailUrl,
                  loading: "lazy",
                  onError: _cache[0] || (_cache[0] = ($event: any) => (_ctx.imgFailed = true))
                }, null, 40, _hoisted_5))
          ])
        ]),
        (!_ctx.compactDisplay)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.truncateLong(_ctx.element.name)), 1),
              (_ctx.sortedClasses !== null)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("span", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedClasses, (classification) => {
                        return (_openBlock(), _createElementBlock("span", {
                          class: "tag is-warning",
                          key: classification.id,
                          title: classification.ml_class.name
                        }, _toDisplayString(_ctx.truncateShort(classification.ml_class.name)), 9, _hoisted_9))
                      }), 128))
                    ]),
                    _hoisted_10
                  ], 64))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["to", "title"]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("span", {
        class: "type",
        title: _ctx.elementTypeName
      }, _toDisplayString(_ctx.truncateShort(_ctx.elementTypeName)), 9, _hoisted_12),
      (!_ctx.disabled)
        ? (_openBlock(), _createBlock(_component_DeleteModal, {
            key: 0,
            target: _ctx.element
          }, {
            default: _withCtx(({ open, canDelete }) => [
              _createElementVNode("button", {
                title: canDelete ? 'Delete this element' : 'You do not have the required rights to delete this element',
                class: _normalizeClass([canDelete ? 'has-text-danger' : 'has-text-grey', "button"]),
                onClick: _withModifiers(open, ["prevent"])
              }, _hoisted_15, 10, _hoisted_13)
            ]),
            _: 1
          }, 8, ["target"]))
        : _createCommentVNode("", true),
      (_ctx.hasPreview)
        ? (_openBlock(), _createBlock(_component_PreviewDropdown, {
            key: 1,
            "element-id": _ctx.element.id
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          }, 8, ["element-id"]))
        : _createCommentVNode("", true),
      (_ctx.dataset)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            title: _ctx.dataset.state === 'open' ? 'Remove this element from dataset' : 'Only open datasets can be edited',
            class: "button has-text-danger",
            type: "button",
            disabled: _ctx.dataset.state !== 'open',
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.removeElementModal = true))
          }, _hoisted_19, 8, _hoisted_17))
        : _createCommentVNode("", true),
      (_ctx.dataset && _ctx.set && _ctx.dataset.state === 'open')
        ? (_openBlock(), _createBlock(_component_RemoveModal, {
            key: 3,
            modelValue: _ctx.removeElementModal,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.removeElementModal) = $event)),
            dataset: _ctx.dataset,
            set: _ctx.set.name,
            element: _ctx.element
          }, null, 8, ["modelValue", "dataset", "set", "element"]))
        : _createCommentVNode("", true),
      (_ctx.isVerified && _ctx.hasFeature('selection') && !_ctx.disabled)
        ? (_openBlock(), _createElementBlock("button", {
            key: 4,
            title: "Add this element to the selection",
            class: _normalizeClass(["button", { 'is-success': _ctx.selected }]),
            onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleSelection && _ctx.toggleSelection(...args)), ["prevent"])),
            disabled: !_ctx.isVerified || undefined
          }, _hoisted_22, 10, _hoisted_20))
        : _createCommentVNode("", true)
    ])
  ]))
}